import ModalContainer from 'components/modal/modal-container'

import ModalActions from 'components/modal/modal-actions'
import { Button } from '@mui/material'

import { closeModal } from 'actions/app'

import { restoreFarms } from 'api/farm'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { type GridRowId } from '@mui/x-data-grid'

type RestoreFarmsProps = {
  selectedFarmIds: number[] | string[] | GridRowId[]
  callback: Function
}

export default function RestoreFarms(props: RestoreFarmsProps) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { selectedFarmIds, callback } = props

  const closePopup = () => dispatch(closeModal())

  const restore = () => {
    if (selectedFarmIds && selectedFarmIds.length > 0) {
      //@ts-expect-error
      dispatch(restoreFarms(selectedFarmIds, callback))
      dispatch(closeModal())
    } else {
      dispatch(closeModal())
    }
  }
  return (
    <ModalContainer>
      <div>
        {t('restore_items', {
          count: selectedFarmIds?.length || 0,
          item: selectedFarmIds?.length > 1 ? t('farms') : t('farm'),
        })}
      </div>
      <ModalActions>
        <Button variant="contained" color="secondary" onClick={closePopup}>
          {t('cancel')}
        </Button>
        <Button variant="contained" color="primary" onClick={restore}>
          {t('restore')}
        </Button>
      </ModalActions>
    </ModalContainer>
  )
}
